import get from 'lodash/get';

const styles = ({ color, theme }) => ({
    notificationContainer: {
      minWidth: '200px !important',
      width: 'auto !important',
      left: '35% !important',
      backgroundColor: get(color, 'white'),
      color: get(color, 'black'),
      fontWeight: 800,
    },
    content: {
      margin: get(theme, 'margin.m36'),
      minHeight: 'calc(100vh - 500px)',
    },
  });

  export default styles;
